module.exports = __webpack_public_path__ + "img/openpay.464fa409.svg";